import { Phrases } from 'libs/end-to-end/src/phrases';
import { englishPhrases } from 'libs/end-to-end/src/english-phrases';

export const englishPhrasesPd: Phrases = {
  ...englishPhrases,
  successPhenotypeV2Subtitle: () =>
    "We've analyzed data from multiple sources to identify the key attributes linked to achieving the target outcome. Leverage these factors as a framework to guide your optimization efforts.",
  successPhenotypeV2EmptyStateTitle: () =>
    'Dive into the data and uncover key factors of optimized decisions.',
  successPhenotypeV2EmptyStateSubtitle: () =>
    'Customize the fields to generate personalized Success Factors tailored to specific outcomes.',
};
